import { DialogOverlay, DialogContent, DialogProps } from "@reach/dialog";

import { ProductsFetch, Plan } from "@/api/products";
import { useProductStore } from "@/store/product";

import Text from "@/components/Text";
import ProductCard from "@/components/ProductCard";
import Glider from "@/components/Glider";

type ProductsDialogProps = DialogProps & {
  onDismiss?(): void;
};

const ProductsDialog = ({
  onDismiss,
  isOpen,
  ...rest
}: ProductsDialogProps) => {
  const { data: products } = ProductsFetch();
  const setProduct = useProductStore((product) => product.setProduct);

  const handleProductSelect = (product: Plan) => {
    setProduct(product);
    onDismiss?.();
  };

  return (
    <DialogOverlay
      className="fixed bottom-0 left-0 right-0 top-0 z-50 overflow-auto"
      style={{ backgroundColor: "hsla(0, 0%, 0%, 0.33)" }}
      onDismiss={onDismiss}
      isOpen={isOpen}
    >
      <DialogContent
        {...rest}
        className="shadow mx-auto my-10 w-full rounded-md border border-gray-100 bg-white py-8 md:w-2/3 lg:w-2/3"
        aria-label="Trocar plano"
      >
        <header className="relative mx-6 flex items-center justify-center pb-8 md:px-8">
          <Text as="h2" size="xl" className="pr-8">
            Trocar plano
          </Text>
          <button
            type="button"
            className="min-w-10 absolute right-0 h-10 rounded-full bg-gray-200 hover:bg-gray-300 focus:scale-90 focus:bg-gray-300 focus:outline-none"
            onClick={onDismiss}
          >
            <span
              className="text-xl text-gray-800"
              aria-hidden
              aria-label="Close"
            >
              ×
            </span>
          </button>
        </header>

        <div className="glider-contain">
          <Glider>
            {products?.map((product) => (
              <div key={product.nome} className="px-2">
                <ProductCard product={product} onSelect={handleProductSelect} />
              </div>
            ))}
          </Glider>
        </div>
      </DialogContent>
    </DialogOverlay>
  );
};

export default ProductsDialog;
